const ReportPage = () => {
  return (
    <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 p-8 font-sans mx-auto my-8 max-w-screen-xl rounded-lg shadow-lg">
        <header className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Community Impacts Report</h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Vivamus at urna dui.
            </p>
        </header>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Economic Development Overview</h2>
            <p className="text-lg text-gray-700 mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vehicula mi a nulla scelerisque, vel hendrerit magna dapibus. Aliquam malesuada erat sed orci dictum, sed venenatis nulla consequat.
            </p>

            <p className="text-lg text-gray-700 mb-6">
                Integer viverra neque sit amet nunc auctor, ac suscipit risus sollicitudin. Nam at augue sit amet urna maximus lobortis non at elit. Curabitur venenatis lacinia urna, eget ullamcorper metus eleifend id.
            </p>
        </section>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Community Demographics & Analysis</h2>
            <p className="text-lg text-gray-700 mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vehicula mi a nulla scelerisque, vel hendrerit magna dapibus. Aliquam malesuada erat sed orci dictum, sed venenatis nulla consequat.
            </p>

            <p className="text-lg text-gray-700 mb-6">
                Integer viverra neque sit amet nunc auctor, ac suscipit risus sollicitudin. Nam at augue sit amet urna maximus lobortis non at elit. Curabitur venenatis lacinia urna, eget ullamcorper metus eleifend id.
            </p>
        </section>  

        <section className="mb-16">
            <div className="flex justify-center items-center bg-gray-200 rounded-lg">
            <iframe
                src="https://microdashboard.caimaps.net/d4d7640a-cfc4-40fe-8e00-4ff07c5d6b48"
                title="Micro Dashboard"
                width="100%"
                height="100%"
                className="rounded-lg h-[340px] overflow-hidden"
            />
            </div>
        </section>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Environmental Initiatives & Green Energy</h2>
            <p className="text-lg text-gray-700 mb-6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus in nisl at ante pretium gravida. Integer gravida, purus eget vehicula fermentum, odio augue tincidunt purus, ac auctor odio magna et urna. Vivamus ut felis eu tortor scelerisque condimentum.
            </p>

            <p className="text-lg text-gray-700 mb-6">
            Aliquam erat volutpat. Sed vehicula erat vel leo lacinia, ac ullamcorper mauris placerat. Ut porttitor nisi sed diam vehicula, ac efficitur mauris mollis. Integer at consequat elit. Quisque vel quam ut purus laoreet tincidunt. Vivamus viverra mauris non dui iaculis, a fringilla nunc tincidunt.
            </p>

            <p className="text-lg text-gray-700">
            Curabitur auctor, ante eget tempus cursus, odio purus pretium magna, sit amet gravida purus nisi eget nisl. Ut euismod ex vitae orci tincidunt pharetra. Vivamus fringilla ex ac leo lacinia tempus. Pellentesque auctor justo sit amet nisl efficitur, vel varius purus fermentum.
            </p>
        </section>

        <section className="mb-16">
            <div className="flex justify-center items-center bg-gray-200 rounded-lg">
            <iframe
                src="https://microdashboard.caimaps.net/48c6dbca-44eb-4cba-90af-8ea005fb2038"
                title="Micro Dashboard"
                width="100%"
                height="100%"
                className="rounded-lg h-[450px] overflow-hidden"
            />
            </div>
        </section>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Market Trends & Insights</h2>
            <p className="text-lg text-gray-700 mb-6">
            In vestibulum ligula sed suscipit malesuada. Integer egestas consequat mauris, id condimentum nisl tincidunt sit amet. Curabitur viverra suscipit ligula ac facilisis. Donec fermentum ipsum neque, non gravida neque posuere vitae.
            </p>

            <p className="text-lg text-gray-700 mb-6">
            Phasellus vitae ante nec libero fringilla egestas. Nunc pretium, erat ac elementum tristique, urna dolor pretium orci, id vehicula nisl ante non neque. Nam ut felis quis eros porttitor ultricies.
            </p>
        </section>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Development Projects & Initiatives</h2>
            <p className="text-lg text-gray-700 mb-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nulla id feugiat tincidunt, sapien turpis luctus massa, id facilisis lectus sapien vel mauris.
            </p>

            <ul className="space-y-4">
                <li className="bg-gray-100 p-4 rounded-lg shadow-md">
                    <h3 className="text-lg font-semibold text-gray-800">Lorem Ipsum Dolor</h3>
                    <p className="text-gray-700">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce feugiat, velit ac cursus dictum, nulla nisl tincidunt nunc, sit amet tincidunt orci sapien at magna.
                    </p>
                </li>
                <li className="bg-gray-100 p-4 rounded-lg shadow-md">
                    <h3 className="text-lg font-semibold text-gray-800">Sed Euismod Nulla</h3>
                    <p className="text-gray-700">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ut ligula vel ligula blandit tempus non at purus.
                    </p>
                </li>
                <li className="bg-gray-100 p-4 rounded-lg shadow-md">
                    <h3 className="text-lg font-semibold text-gray-800">Facilisis Lectus Sapien</h3>
                    <p className="text-gray-700">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget felis auctor, rhoncus tortor at, viverra lacus.
                    </p>
                </li>
            </ul>
        </section>

        <section className="mb-16">
            <div className="flex justify-center items-center bg-gray-200 rounded-lg">
            <iframe
                src="https://microdashboard.caimaps.net/a6c0adb0-6af8-4332-b88b-7faf0c6b2da9"
                title="Micro Dashboard"
                width="100%"
                height="100%"
                className="rounded-lg h-[450px] overflow-hidden"
            />
            </div>
        </section>

        <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">Strategic Insights</h2>
            <p className="text-lg text-gray-700 mb-6">
            Mauris consequat dolor sed magna dignissim, sed auctor ligula tempus. Proin suscipit risus sit amet est aliquam, et ullamcorper ante tincidunt. Vivamus gravida risus ut purus tincidunt, ac rhoncus felis suscipit.
            </p>

            <p className="text-lg text-gray-700 mb-6">
            Sed ultricies risus vel magna dictum, vel tincidunt purus bibendum. Aliquam erat volutpat. Quisque fringilla dolor felis, in convallis enim vestibulum id. Phasellus id auctor risus. Integer consequat orci ut dolor ullamcorper, non consequat ante efficitur.
            </p>
        </section>

        <footer className="text-center mt-16">
            <p className="text-sm text-gray-600">© 2025 Community Attributes Inc.</p>
        </footer>
    </div>
  );
};

export default ReportPage;
